import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";
import { Phone } from "lucide-react";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="py-20 md:py-28 px-6 border-t border-olive/15"
      style={{ backgroundColor: "#F4F0E6" }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-[11px] tracking-[0.4em] uppercase text-olive mb-6"
        >
          {t.contact.label}
        </motion.p>
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="font-serif text-3xl md:text-4xl text-wine mb-12"
        >
          {t.contact.title}
        </motion.h3>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-10 sm:gap-20 mb-16">
          <Contact name={t.contact.marcel} number="+34 617 02 19 05" testid="contact-marcel" />
          <span className="hidden sm:block w-px h-12 bg-gold/40" />
          <Contact name={t.contact.aida} number="+34 648 64 22 82" testid="contact-aida" />
        </div>

        <div className="font-script text-5xl text-wine mb-3">
          Marcel & Aida
        </div>
        <p className="font-editorial italic text-olive">
          {t.footer.with} · {t.footer.year}
        </p>
      </div>
    </footer>
  );
};

const Contact = ({ name, number, testid }) => (
  <a
    href={`tel:${number.replace(/\s/g, "")}`}
    data-testid={testid}
    className="group flex items-center gap-4 transition-all duration-500 hover:-translate-y-0.5"
  >
    <div className="w-11 h-11 rounded-full border border-olive/30 flex items-center justify-center group-hover:border-wine group-hover:bg-wine transition-all duration-500">
      <Phone className="w-4 h-4 text-olive group-hover:text-cream transition-colors duration-500" strokeWidth={1.5} />
    </div>
    <div className="text-left">
      <div className="text-[10px] tracking-[0.3em] uppercase text-olive">{name}</div>
      <div className="font-serif text-lg text-wine">{number}</div>
    </div>
  </a>
);

export default Footer;
